import React from "react";
import { Colors } from "../../Constants/colors";
import { SelectedParents as SelectedParentsInterface } from "../../Redux/Slices/studentAdmission.slice";
interface Props {
  selectedParents?: SelectedParentsInterface;
  onParentsChange: () => unknown;
}
export const SelectedParents = ({
  selectedParents,
  onParentsChange,
}: Props) => {
  return (
    <>
      <div className="text-sm mb-4" style={{ color: Colors.Grey }}>
        You have chosen the following parent. If you need to make changes,
        please feel free to{" "}
        <span
          style={{ color: Colors.AshRose, cursor: "pointer" }}
          className="underline"
          onClick={onParentsChange}
        >
          select another parent
        </span>
        .
      </div>

      <div className="flex gap-x-8 mt-4">
        <div className="flex flex-1 flex-col gap-y-4 w-3/5">
          <ParentsDetail title="Name" value={selectedParents?.name || ""} />
          <ParentsDetail
            title="Parental relationship"
            value={selectedParents ? selectedParents.parentalRelationship : ""}
          />
          <ParentsDetail
            title="Mobile number"
            value={selectedParents?.mobile || ""}
          />
          <ParentsDetail
            title="Address"
            value={selectedParents?.address || ""}
          />
        </div>
        {/* <div className="w-2/5"> test</div> */}
      </div>
    </>
  );
};
const ParentsDetail = ({ title, value }: { title: string; value: string }) => {
  return (
    <div
      className="flex gap-1 font-extra text-base"
      style={{ color: Colors.Grey }}
    >
      <div
        className="font-medium"
        style={{ color: Colors.DarkGrey }}
      >{`${title} :`}</div>
      <div className="flex-1">{value}</div>
    </div>
  );
};
